import React from 'react';

export const Loader = ({ label = 'Loading' }) => (
  <div className='flex min-h-[60vh] items-center justify-center bg-[#20272A]'>
    <div className='flex flex-col items-center gap-4'>
      <div className='relative h-12 w-12'>
        <span className='absolute inset-0 rounded-full border border-white/10' />
        <span className='absolute inset-0 animate-spin rounded-full border-2 border-transparent border-t-[#B88A3B]' />
      </div>
      <span className='eyebrow text-[#F6F5F1]/50'>{label}</span>
    </div>
  </div>
);
